import {
  ListStoreDefault,
  ListRequestHandler,
  ListFilterHandler,
  ListSuccessHandler,
  locationChangePersist,
 } from 'js/helpers/reducers.js';

import {
  FETCH_PUBLISHERS_LIST,
  FETCHED_PUBLISHERS_LIST,
  SET_PUBLISHERS_FILTER,
  SAVE_RICH_PUBLISHER_DATA,
  REMOVE_RICH_PUBLISHER_DATA,
} from 'components/Global/Filters/actions.js';


const defaultState = {
  publishersList: ListStoreDefault({
    pageNum: 1,
    pageSize: 20,
    searchQuery: '',
    searchBy: '',
  }),
  richPublisherData: [],
};

const PublishersListReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return locationChangePersist(state, action, defaultState, {
        sections: ['richPublisherData'],
        pathToMatch: `/blueprint/search`,
      });
    case FETCH_PUBLISHERS_LIST:
      return ListRequestHandler(state, action, 'publishersList');
    case FETCHED_PUBLISHERS_LIST:
      return ListSuccessHandler(state, action, 'publishersList');
    case SET_PUBLISHERS_FILTER:
      return ListFilterHandler(state, action, 'publishersList');
    case SAVE_RICH_PUBLISHER_DATA:
      return { ...state, richPublisherData: action.data };
    case REMOVE_RICH_PUBLISHER_DATA:
      return { ...state, richPublisherData: action.id ? state.richPublisherData.filter(({ public_id }) => public_id !== action.id) : [] };
    default:
      return Object.assign({}, state);
  }
};

export default PublishersListReducer;
